export let IMAGES_BASE_URL = {imageBaseUrl : "https://anydatapoint.net/"};

//let version = "v2.5.129.136";
//let Stockversion = "v2.5.127.128.139";
import {version, Stockversion} from "./version"


export let AppConfig = {


  /********** *******************************************************************
   *                                                                            *
   *    Set Following Variable for the LOCAL, EV and COMMERCIAL environment    *
   *                                                                            *
   * ****************************************************************************/

  ENVIRONMENT:"COMMERCIAL", //Possible-Values ['LOCAL', 'DEV', 'COMMERCIAL']

  /*URL Set For Local Environment*/
  LOCAL_DTAPI_PK:"localhost:8081/api/v1",
  LOCAL_RTAPI_PK:"localhost:8081/api/v2",

  LOCAL_DTAPI_NA:"localhost:8081/api/v1",
  LOCAL_RTAPI_NA:"localhost:8081/api/v2",

  LOCAL_RA_SERVICE:"http://localhost:8080",


  /*URL Set For DEV Environment*/
  DEV_DTAPI_PK:"https://dtapipk.jazzba.io/api/v1",
  DEV_RTAPI_PK:"https://rtapipk.jazzba.io/api/v2",

  DEV_DTAPI_NA:"https://dtapius.jazzba.io/api/v1",
  DEV_RTAPI_NA:"https://rtapius.jazzba.io/api/v2",

  DEV_RA_SERVICE:"https://raservice.jazzba.io",
  DEV_ApiURL_billing: "https://adppayus.jazzba.io/api/v1",
  DEV_Jazzba_Manage: "https://manageus.jazzba.io",


  /*URL Set For COMMERCIAL Environment*/
  COMMERCIAL_DTAPI_PK:"https://dtapipk.jazzba.io/api/v1",
  COMMERCIAL_RTAPI_PK:"https://rtapipk.jazzba.io/api/v2",

  COMMERCIAL_DTAPI_NA:"https://dtapius.jazzba.io/api/v1",
  COMMERCIAL_RTAPI_NA:"https://rtapius.jazzba.io/api/v2",

  COMMERCIAL_RA_SERVICE:"https://raservice.jazzba.io",
  COMMERCIAL_ApiURL_billing: "https://adppayus.jazzba.io/api/v1",
  COMMERCIAL_Jazzba_Manage: "https://manageus.jazzba.io"

};

export let Constants :any = {
	country:"US",
   version: Stockversion,
   appVersion:"IntelliRep "+version ,
   stockVersion:"IntelliStock" + Stockversion,
   webstoreVersion:"IntelliCommerce "+version ,
   intelliStockVersion: "IntelliStock " + Stockversion,
	 coreVersion:"IntelliCommerce v2.5.01 beta" ,
	 CopyRight:"Copyright \u00A9 2018-2022 JAZZBA." ,
	 sentryToken:"679f61fc8565454eb926396c680b96fe",
	 allowRightsMsgLogin:true,
	 isDebugmode: true,
	 iCommSentryToken:"https://2a6b713e71514f349362004724942285@sentry.io/857435",
	 iRepSentryToken:"https://82521ff9c7484f42b571d755487846a6@sentry.io/857815",
	 // True for webstore and false for App
   isWebstore: false, // Also add custId as rtApiURL parameter and place images in cust-{{customerID}} folder
   IntelliStockRunningIn: "BROWSER", // NA, BROWSER, APP
   IntelliRepRunningIn: "NA", // NA, BROWSER, APP
	 imageCacheSize: 1024, // MB
	 isImageCacheExpiry: true, // allow to expire cache
	 imageCacheExpirytime: 90,	// Days
	 imagesPreloadBuffer: 100,
	 itemRefreshed:false, // for one time event
   fetchCount: 24, // Items fetch count for Offline mode fetch
   Monthly_License_alias:"ims",
   EDI_Integrations_License_alias:"integrations-edi",
   fulfilment_topup_License_alias:"fulfilment-topup",

	};
export let CollectionAndClasses:any = {collection:[0],subCollection:[0],categories:[0],tags:[0]};

export let ApplicationVariables = { isOffline:false , connectionType:"wifi"};

export let LicenseName = ["LiveRead", "anyOtherName", "InstantRead"];

export function isIntelliStock(){
  if(Constants.IntelliStockRunningIn === "BROWSER" || Constants.IntelliStockRunningIn === "APP")
  {
    return true;
  }
  else{
    return false;
  }
}




// WEBPACK FOOTER //
// ./src/providers/config.ts